module.exports = __webpack_public_path__ + "pattern5.372dee6df561fd2ed153.png";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/src/assets/images/pattern5.png
// module id = ../../../../../src/assets/images/pattern5.png
// module chunks = styles